import { retargetingConditionEstimation, retargetingGoals } from '../../graphql/queries/grid/retargeting';
import { mapRulesGroupsToApiFormat } from '../../mappers/retargeting/retargeting';
import { GdGoalType, RetargetingConditionEstimationQuery, RetargetingGoalsQuery } from '../../typings/graphql-grid';
import { RetargetingConditionDataRulesGroup } from '../../typings/retargeting';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export class RetargetingDataProvider extends BaseDataProvider {
    public getGoalsForRetargetingConditions = (login: string): Promise<RetargetingGoalsQuery> => {
        return this.createQuery<RetargetingGoalsQuery>(retargetingGoals, {
            variables: {
                login,
                input: {
                    filter: {
                        goalTypeIn: [GdGoalType.ECOMMERCE, GdGoalType.SEGMENT, GdGoalType.AUDIENCE, GdGoalType.GOAL]
                    }
                }
            }
        }).then(result => result.data);
    };

    public getRetargetingConditionEstimation = (
        rulesGroups: Array<RetargetingConditionDataRulesGroup>
    ): Promise<RetargetingConditionEstimationQuery> => {
        return this.createQuery<RetargetingConditionEstimationQuery>(retargetingConditionEstimation, {
            variables: {
                input: {
                    conditionRules: mapRulesGroupsToApiFormat(rulesGroups)
                }
            }
        }).then(result => result.data);
    };
}
